"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHistoryOfStates = void 0;

var React = __importStar(require("react"));

var utils_1 = require("./utils");

var use_first_mount_state_1 = require("./use-first-mount-state");

function useHistoryOfStates(initialState, capacity, name, initialHistory) {
  if (capacity === void 0) {
    capacity = 10;
  }

  if (name === void 0) {
    name = '';
  }

  if (initialHistory === void 0) {
    initialHistory = [];
  }

  if (capacity < 1) {
    throw new Error("Capacity in the history of states " + (name.length > 0 ? name : 'unknown') + " has to greater than 1, got " + capacity);
  }

  var isFirstMount = use_first_mount_state_1.useFirstMountState();

  var _a = React.useState(initialState),
      state = _a[0],
      innerState = _a[1];

  var history = React.useRef(initialHistory !== null && initialHistory !== void 0 ? initialHistory : []);
  var historyPosition = React.useRef(0);

  if (isFirstMount) {
    if (history.current.length > 0) {
      if (history.current[history.current.length - 1] !== initialState) {
        history.current.push(initialState);
      }

      if (history.current.length > capacity) {
        history.current = history.current.slice(history.current.length - capacity);
      }
    } else {
      history.current.push(initialState);
    }

    if (history.current.length > 0) {
      historyPosition.current = history.current.length - 1;
    }
  }

  var setState = React.useCallback(function (newState) {
    innerState(function (prevState) {
      var nextState = utils_1.resolveHookState(newState);

      if (nextState !== prevState) {
        if (historyPosition.current < history.current.length - 1) {
          history.current = history.current.slice(0, historyPosition.current + 1);
        }

        historyPosition.current = history.current.push(nextState) - 1;

        if (history.current.length > capacity) {
          history.current = history.current.slice(history.current.length - capacity);
        }
      }

      return nextState;
    });
  }, [state, capacity]);
  var historyState = React.useMemo(function () {
    return {
      history: history.current,
      position: historyPosition.current,
      capacity: capacity,
      back: function back(amount) {
        if (amount === void 0) {
          amount = 1;
        }

        if (!!historyPosition.current) {
          innerState(function () {
            historyPosition.current -= Math.min(amount, historyPosition.current);
            return history.current[historyPosition.current];
          });
        }
      },
      forward: function forward(amount) {
        if (amount === void 0) {
          amount = 1;
        }

        if (!(historyPosition.current === history.current.length - 1)) {
          innerState(function () {
            historyPosition.current = Math.min(historyPosition.current + amount, history.current.length - 1);
            return history.current[historyPosition.current];
          });
        }
      },
      go: function go(position) {
        if (!(position === historyPosition.current)) {
          innerState(function () {
            historyPosition.current = position < 0 ? Math.max(history.current.length + position, 0) : Math.min(history.current.length - 1, position);
            return history.current[historyPosition.current];
          });
        }
      }
    };
  }, [state]);
  return [state, setState, historyState];
}

exports.useHistoryOfStates = useHistoryOfStates;